import React, { useState, useEffect } from 'react';
import {
  Table, Card, Col, Spinner, Tabs, Tab,
} from 'react-bootstrap';
import axios from 'axios';
import { Content } from '../styles';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import Pengajuan from './pengajuan';
import config from '../../../../config';

const DaftarApprovalPartisipasi = () => {
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [activeFilter, setActiveFilter] = useState('menunggu persetujuan');

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/?status=${activeFilter}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const simplifyData = data.map((
          (content) => (
            {
              nama: content.mahasiswa.user.name.toUpperCase(),
              npm: content.mahasiswa.user.npmnip,
              prodi: content.mahasiswa.prodi,
              url: `detail/${content.id}`,
              status: content.status.toUpperCase(),
            }
          )
        ));
        setDatas(simplifyData);
      },
    );
    setLoading(false);
  }, [activeFilter]);

  return (
    <>
      <Navbar />
      <Header />
      <Content className={Content}>
        <Card>
          <Card.Header>
            <h1 className="text-center font-32">
              Approval Pengajuan Partisipasi Kuliah Umum
            </h1>
          </Card.Header>
          <Card.Body>
            <Col md={{ span: 8, offset: 2 }}>
              <Tabs
                className="tabkum nav-fill"
                id="controlled-tab"
                data-testid="date"
                activeState={activeFilter}
                onSelect={(k) => setActiveFilter(k)}
                style={{ margin: '0' }}
              >
                <Tab eventKey="menunggu persetujuan" title="Menunggu Persetujuan" />
                <Tab eventKey="disetujui" title="Disetujui" />
                <Tab eventKey="ditolak" title="Ditolak" />
              </Tabs>
              <Table striped bordered hover className="text-center">
                <thead>
                  <tr>
                    <th> No </th>
                    <th> Nama Pengaju </th>
                    <th> NPM </th>
                    <th> Program Studi </th>
                    <th> Detail </th>
                  </tr>
                </thead>
                <tbody>
                  {datas.map((
                    (data, index) => (
                      <Pengajuan
                        number={index + 1}
                        nama={data.nama}
                        npm={data.npm}
                        prodi={data.prodi}
                        url={data.url}
                      />
                    )
                  ))}
                </tbody>
              </Table>
            </Col>
          </Card.Body>
        </Card>
      </Content>
    </>
  );
};

export default DaftarApprovalPartisipasi;
